/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliTeacherInstitutionDto } from '../../models/amoxcalli-teacher-institution-dto';

export interface ApiTeacherInstitutionsMineGet$Json$Params {
}

export function apiTeacherInstitutionsMineGet$Json(http: HttpClient, rootUrl: string, params?: ApiTeacherInstitutionsMineGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliTeacherInstitutionDto>>> {
  const rb = new RequestBuilder(rootUrl, apiTeacherInstitutionsMineGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliTeacherInstitutionDto>>;
    })
  );
}

apiTeacherInstitutionsMineGet$Json.PATH = '/api/teacher-institutions/mine';
